import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { alpha, useTheme } from '@material-ui/core/styles';

const PHASE_COLORS = ['#e65100', '#f57c00', '#ff9800'];

const ProductionPhases = ({ section = {} }) => {
  const theme = useTheme();
  const axes = Array.isArray(section.axes) ? section.axes : [];
  const highlights = Array.isArray(section.highlights) ? section.highlights : [];

  return (
    <Box py={{ xs: 4, md: 6 }}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="secondary"
        align="center"
      >
        Flujo de producción
      </Typography>
      <Typography variant="h4" align="center" sx={{ fontWeight: 800, mb: 1 }}>
        {section.title || 'Las tres fases de cada programa'}
      </Typography>
      {section.subtitle && (
        <Typography variant="h6" align="center" color="textSecondary" sx={{ mb: 1 }}>
          {section.subtitle}
        </Typography>
      )}
      {section.description && (
        <Typography align="center" color="textSecondary" sx={{ maxWidth: 720, mx: 'auto', mb: 4 }}>
          {section.description}
        </Typography>
      )}

      <Grid container spacing={3} sx={{ mb: highlights.length > 0 ? 4 : 0 }}>
        {axes.map((axis, i) => (
          <Grid item xs={12} md={4} key={axis.title}>
            <Card
              elevation={0}
              sx={{
                height: '100%',
                border: `1px solid ${alpha(PHASE_COLORS[i] || theme.palette.primary.main, 0.35)}`,
                borderTop: `4px solid ${PHASE_COLORS[i] || theme.palette.primary.main}`,
              }}
            >
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                  {axis.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {axis.text}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {highlights.length > 0 && (
        <Grid container spacing={2} justifyContent="center">
          {highlights.map((h) => (
            <Grid
              item
              xs={12}
              sm={highlights.length <= 3 ? 4 : 6}
              md={highlights.length === 3 ? 4 : highlights.length === 2 ? 6 : 3}
              key={h.label}
            >
              <Box textAlign="center" p={2}>
                <Typography variant="h3" color="primary" sx={{ fontWeight: 800 }}>
                  {h.value}
                </Typography>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mt: 0.5 }}>
                  {h.label}
                </Typography>
                {h.subtitle && (
                  <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
                    {h.subtitle}
                  </Typography>
                )}
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

ProductionPhases.propTypes = {
  section: PropTypes.object,
};

export default ProductionPhases;
